import { COMPONENTS } from '../utils/constants.json';

const INITIAL_STATE = {
  drawer: {
    open: false,
  },
  loader: false,
  modal: {
    isOpen: false,
    contentId: '',
  },
};
/**
 * Reducer - to update services state
 * @param {Object} state initial/default services state.
 * @param {Object} action to be performed
 * @return {Object} new services state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case COMPONENTS.DRAWER.OPEN:
      return { ...state, drawer: { open: true } };
    case COMPONENTS.DRAWER.CLOSE:
      return { ...state, drawer: { open: false } };
    case COMPONENTS.LOADER.SHOW:
      return { ...state, loader: true, ...payload };
    case COMPONENTS.LOADER.HIDE:
      return { ...state, loader: false, ...payload };
    case COMPONENTS.MODAL.OPEN:
      return { ...state, modal: { isOpen: true, ...payload } };
    case COMPONENTS.MODAL.CLOSE:
      return { ...state, modal: { isOpen: false, contentId: '' } };
    default:
      return { ...state };
  }
}
